import { FC } from 'react';
import Text from '../Text/Text';
import styles from './ActionChip.module.css';
import cx from 'classnames';

export interface ActionChipProps {
  'title': string;
  'primaryText': string;
  'secondaryText'?: string;
  'onClick'?: VoidFunction;
  'className'?: string;
  'isSelected'?: boolean;
  'data-testid'?: string;
}

const ActionChip: FC<ActionChipProps> = ({
  title,
  primaryText,
  secondaryText,
  onClick,
  className,
  isSelected = false,
  'data-testid': dataTestId = 'action-chip',
}) => {
  return (
    <div
      className={cx(className, styles.container, isSelected && styles.selected)}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <Text as="h4" className={styles.title}>
        {title}
      </Text>
      <div className={styles.textContainer}>
        <Text className={styles.primaryText}>{primaryText}</Text>
        {secondaryText && <Text className={styles.secondaryText}>{secondaryText}</Text>}
      </div>
    </div>
  );
};

export default ActionChip;
